export default __webpack_public_path__ + "static/media/radioChecked.47c9b873.svg";